import { gql } from '@apollo/client';

const CITIES = gql`
  query Cities($search: String!) {
    cities(search: $search, limit: 50) {
      id
      location {
        latitude
        longitude
      }
      name
      zipcode
    }
  }
`;

export default CITIES;
